import { render, staticRenderFns } from "./wxBind.vue?vue&type=template&id=55dad877&scoped=true"
import script from "./wxBind.vue?vue&type=script&lang=js"
export * from "./wxBind.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/login.scss?vue&type=style&index=0&id=55dad877&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dad877",
  null
  
)

export default component.exports